<template>
<header>
 <nav class="navbar navbar-expand-lg navbar-light bg-transparent fixed-top">
  <a class="navbar-brand" href="#"><img src="@/assets/logo-knittygritty.svg"></a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item active">
        <router-link to="/" class="nav-link">Home</router-link> 
      </li>
      <li class="nav-item">
        <router-link to="/about" class="nav-link">About</router-link>
      </li> 
      <li class="nav-item">
        <router-link to="/blog" class="nav-link">Blog</router-link>
      </li> 
    </ul>
    <ul class="navbar-nav ml-auto">
     <li class="nav-item">
        <router-link to="/login" class="nav-link">Login</router-link>
      </li> 
    </ul>
    
   
  </div>
</nav>
</header>
</template>

<script>
export default {
  name: 'Header',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
